<template>
<label>
  <input type="checkbox" :checked="checked" v-on:change="toggleChecked" />
  <span />
</label>
</template>

<script>
export default {
  props: ["list", "value"],
  computed: {
    checked() {
      return this.list?.indexOf(this.value)!=-1;
    },
  },
  methods: {
    toggleChecked() {
      if (this.checked)
        this.list?.splice(this.list?.indexOf(this.value), 1);
      else
        this.list?.push(this.value);
    },
  },
}
</script>
